import { initialsValue } from "../../../../helpers";
import AvatarUpload from "../../../common/AvatarUpload";
import Button from "../../../form/Button";

const KYC = () => {
  return (
    <>
    
      <h3 className="mb-6 text-lg font-bold">Complete KYC</h3>
      <div class="grid grid-cols-2 gap-4">
        <div>
        <div className="text-sm font-bold mt-6 text-gray-500">Upload PAN Card:</div>
        <div class="flex items-center justify-center border border-gray-300 rounded-lg p-4">
          <AvatarUpload
            // src={
            //   values?.image instanceof File
            //     ? URL.createObjectURL(values?.image)
            //     : values?.image
            // }
            // onChange={(file) => {
            //   handleChange({ target: { name: "image", value: file } });
            // }}
            alt="PAN"
            initial={initialsValue("PAN")}
          />
        </div>
        </div>

        <div>
        <div className="text-sm font-bold mt-6 text-gray-500">Upload Voter ID Card:</div>
        <div class="flex items-center justify-center border border-gray-300 rounded-lg p-4">
          <AvatarUpload
            // src={
            //   values?.image instanceof File
            //     ? URL.createObjectURL(values?.image)
            //     : values?.image
            // }
            // onChange={(file) => {
            //   handleChange({ target: { name: "image", value: file } });
            // }}
            alt="PAN"
            initial={initialsValue("Voter Id")}
          />
        </div>
        </div>

<div>
        <div className="text-sm font-bold mt-6 text-gray-500">Upload Driver’s license:</div>
        <div class="flex items-center justify-center border border-gray-300 rounded-lg p-4">
          <AvatarUpload
            // src={
            //   values?.image instanceof File
            //     ? URL.createObjectURL(values?.image)
            //     : values?.image
            // }
            // onChange={(file) => {
            //   handleChange({ target: { name: "image", value: file } });
            // }}
            alt="PAN"
            initial={initialsValue("Driver License")}
          />
        </div>
        </div>
      </div>

      <div className="pt-3 pb-6 flex justify-end">
        <Button buttonType="submit" buttonClasses={"min-w-36"} buttonLabel={"Update KYC Details"} />
      </div>
    </>
  );
};
export default KYC;
